import React, { useState, useEffect } from 'react'
import { css } from '@emotion/react'
import { LoadersStyle } from './style'
import MoonLoader from 'react-spinners/MoonLoader'
const override = css`
  display: block;
  margin: 0 auto;
  border-color: 'grey';
`
const Loaders = ({ load, style }) => {
  let [loading, setLoading] = useState(load)
  let [color, setColor] = useState('#4b4acb')
  useEffect(() => {
    let mount = true
    if (mount) {
      setLoading(load)
    }
    return () => {
      mount = false
    }
  }, [load])
  return (
    <LoadersStyle className="mainContainer" style={style}>
      <MoonLoader color={color} loading={loading} css={override} size={25} />
    </LoadersStyle>
  )
}
Loaders.defaultProps = {
  load: false,
  style: {},
}
export default Loaders
